import apiClient from "@/api/client";

export interface WorkloadExplicitAllocation {
  employee_id: string;
  employee_name: string;
  fraction: number;
  cost?: string | null;
}

export interface WorkloadEmployeeEntry {
  employee_id: string;
  employee_name: string;
  /** Direct allocation from ProjectEmployeeAllocation (0 if none). */
  explicit_fraction: number;
  /** Share of remaining capacity flowing here via proportional distribution. */
  auto_fraction: number;
  /** explicit + auto, capped at 1. */
  total_fraction: number;
  explicit_cost?: string;
  auto_cost?: string;
  total_cost?: string;
}

export interface WorkloadProjectRow {
  project_id: string;
  project_name: string;
  project_short_name: string;
  client_name: string;
  status: "active" | "suspended" | "inactive";
  /** Used by the stacked bars view — only employees with explicit_fraction > 0. */
  explicit_allocations: WorkloadExplicitAllocation[];
  /** Used by the heatmap — ALL employees contributing (explicit + auto). */
  employees: WorkloadEmployeeEntry[];
  explicit_total_fraction: number;
  auto_allocation_cost?: string;
  total_cost?: string;
}

export interface WorkloadAllEmployee {
  id: string;
  name: string;
  /** False = pracownik nie ma EmployeeSalaryCost, nie kontrybuuje auto. */
  has_salary: boolean;
}

export interface WorkloadSummaryData {
  year: number;
  month: number;
  include_finances: boolean;
  projects: WorkloadProjectRow[];
  /** Wszyscy aktywni internal-pracownicy w okresie — także bez żadnego
   *  przydziału. Frontend powinien renderować całą listę jako wiersze
   *  heatmapy, żeby było widać też "luki". */
  all_employees: WorkloadAllEmployee[];
}

export interface WorkloadSummaryPreferences {
  hidden_employee_ids: string[];
  hidden_project_ids: string[];
}

export const workloadSummaryApi = {
  get: (year: number, month: number) =>
    apiClient
      .get<{ data: WorkloadSummaryData }>("/finances/workload-summary/", {
        params: { year, month },
      })
      .then((res) => res.data.data),

  getPreferences: () =>
    apiClient
      .get<{ data: WorkloadSummaryPreferences }>(
        "/finances/workload-summary/preferences/",
      )
      .then((res) => res.data.data),

  putPreferences: (payload: Partial<WorkloadSummaryPreferences>) =>
    apiClient
      .put<{ data: WorkloadSummaryPreferences }>(
        "/finances/workload-summary/preferences/",
        payload,
      )
      .then((res) => res.data.data),
};
